<template>
  <div
    :class="`formulate-input-element password-field formulate-input-element--${context.type}`"
    :data-type="context.type"
  >
    <input
      :type="showPassword ? 'text' : 'password'"
      v-model="context.model"
      v-bind="context.attributes"
      autocomplete="no"
      @keypress="space($event)"
    />
    <button type="button" @click="showPassword = !showPassword" class="icon-button">
      <span class="visually-hidden"
        >{showPassword ? 'Hide password' : 'Show password'}</span
      >
      <div class="icon-eye">
        <img v-if="!showPassword" src="@/assets/img/join/password_hide.svg" />
        <img v-else src="@/assets/img/join/password_show.svg" />
      </div>
    </button>
  </div>
</template>

<script>
export default {
  name: "CustomPassword",
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showPassword: false,
    };
  },
  methods: {
    space(e) {
      if (e.keyCode == 32) {
        e.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>

<style scoped>
.formulate-input-element {
  position: relative;
}
.visually-hidden {
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}
.icon-button {
  display: flex;
  align-items: center;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  border: 0;
  background: none;
  margin-right: 5px;
  margin-top: 2px;
}
</style>
